import { datadogLogs } from "@datadog/browser-logs";

const useConsoleOnly = process.env.VUE_APP_LOGGER_CONSOLE_ONLY === "true";
const env = process.env.VUE_APP_ENVIRONMENT || "local";

const init = () => {
  datadogLogs.init({
    clientToken: process.env.VUE_APP_LOGGER_DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: process.env.VUE_APP_VERSION || "0.0.0",
    service: "npe",
    env,
  });
  datadogLogs.addLoggerGlobalContext("host", "npe_" + env);

  // no handler - using the default datadog handler for prod (sending to datadog only)
  // http - datadog and console
  // console - console only
  if (useConsoleOnly) {
    datadogLogs.logger.setHandler("console");
  } else if (process.env.NODE_ENV === "production") {
    datadogLogs.logger.setHandler("http");
  } else {
    datadogLogs.logger.setHandler(["http", "console"]);
  }
};

const getLoggingMessage = (message) => {
  let loggingMessage = message;
  if (typeof message === "object") {
    loggingMessage = message.stack || message.toString();
  }
  return loggingMessage;
};

const getLoggingContext = (context) => {
  let loggingContext = context || {};
  // Convert JS Exception to string as it is logged as empty string to datadogs
  if (loggingContext.stack && JSON.stringify(loggingContext) === "{}") {
    loggingContext = loggingContext.stack;
  }
  if (typeof loggingContext === "string") {
    loggingContext = { data: loggingContext };
  }
  return loggingContext;
};

const isHttpError = (error) => {
  return error && error.response && error.request;
};

const logMessage = (type, message, messageContext) => {
  if (process.env.VUE_APP_LOGGER_LEVELS === "all" || process.env.VUE_APP_LOGGER_LEVELS.includes(type)) {
    let loggingContext = {};
    // logging http error to context to provide more data
    if (!messageContext && isHttpError(message)) {
      loggingContext = getLoggingContext(message);
    }
    if (datadogLogs) {
      datadogLogs.logger[type](getLoggingMessage(message), loggingContext);
    } else {
      console.log(message);
    }
  }
};

const loggerGenerator = () => {
  const loggerTypes = ["info", "debug", "warn", "error", "log"];
  const loggerMethods = {};
  // Generate logger methods for each type as { info: () => logMessage() }
  loggerTypes.forEach((loggerType) => {
    loggerMethods[loggerType] = (message, messageContext) => logMessage(loggerType, message, messageContext);
  });
  return loggerMethods;
};

export default {
  ...loggerGenerator(),
  init,
};
